
export default superclass => class extends superclass  {

    getModulatedParameters() {
        let modulated = [];
        for (let parameter of Array.from(new Set(this.getParameters()))) {
            let _count = parameter.lfos.length + parameter.envelopes.length;
            if (_count > 0) {
                modulated.push(parameter);
            }
        }
        return modulated;
    }

    getStats() {
        let count = 0;
        for (let parameter of Array.from(new Set(this.getParameters()))) {
            if (parameter.lfos.length + parameter.envelopes.length > 0) {
            }
            count += parameter.lfos.length + parameter.envelopes.length;
        }
        return count;
    }

    simplifyPatch(percentage) {
        let modulated = this.getModulatedParameters();
        let numToFree = Math.floor(modulated.length * percentage/100);
        for (let i=0; i < numToFree; i++) {
            modulated[i].disconnectFromAllModulators();
        }
    }
}
